// lib
import moment from "moment";
// src
import { plainHash } from "utils/hash";
import { getRequestId } from "utils/presets";

const getRangeId = ({ dateStart, dateEnd }) => plainHash({ dateStart, dateEnd });

// private
const getQueueItem = (query) => ({
  requestId: getRequestId(query),
  rangeId: getRangeId(query),
});

// API
export const updateLoadingInRange = (queue, rangeDateStart, rangeDateEnd) => {
  // range dates are unix timestamps from state.table and need to be converted
  const rangeId = plainHash({
    dateStart: moment(rangeDateStart).toISOString(),
    dateEnd: moment(rangeDateEnd).toISOString(),
  });
  const queueInRange = queue.filter(({ rangeId: id }) => id === rangeId);
  return queueInRange.length > 0;
};

export const updateLoadingsFromRequest = ({ queue }, query) => {
  const queueItem = getQueueItem(query);
  // we update queue from query dates (and not from table one) since
  // the cache system may shorten the table one
  const { dateStart, dateEnd } = query;
  const newQueue = [...queue, queueItem];
  const newIsLoadingInRange = updateLoadingInRange(newQueue, dateStart, dateEnd);
  return {
    loading: true,
    queue: newQueue,
    isLoadingInRange: newIsLoadingInRange,
  };
};

export const updateLoadingsFromResponse = ({ queue, dateStart, dateEnd }, query) => {
  const requestId = getRequestId(query);
  const newQueue = queue.filter(({ requestId: id }) => id !== requestId);
  const newLoading = newQueue.length > 0;
  const newIsLoadingInRange = updateLoadingInRange(newQueue, dateStart, dateEnd);
  return {
    loading: newLoading,
    queue: newQueue,
    isLoadingInRange: newIsLoadingInRange,
  };
};
